import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.orderListing || initialState;

export const selectOrders = createSelector(
  [selectDomain],
  (state) => state.orders
);

export const selectOrderPageLoading = createSelector(
  [selectDomain],
  (state) => state.orderPageLoading
);

export const selectPendingOrderReport = createSelector(
  [selectDomain],
  (state) => state.pendingReport
);

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectDistricts = createSelector(
  [selectDomain],
  (state) => state.districts
);

export const selectSamplers = createSelector(
  [selectDomain],
  (state) => state.samplers
);

export const selectProjectCodesForAddOrder = createSelector(
  [selectDomain],
  (state) => state.projectCodesForAddOrder
);

export const selectProjectCodesForFilter = createSelector(
  [selectDomain],
  (state) => state.projectCodesForFilter
);

export const selectLabs = createSelector([selectDomain], (state) => state.labs);

export const selectCompanies = createSelector(
  [selectDomain],
  (state) => state.companies
);

export const selectLogisticPartners = createSelector(
  [selectDomain],
  (state) => state.logisticPartners
);

export const selectUpdatingLab = createSelector(
  [selectDomain],
  (state) => state.labsUnderUpdate
);

export const selectUpdatingSampler = createSelector(
  [selectDomain],
  (state) => state.samplerUnderUpdate
);

export const selectUpdatingLogistics = createSelector(
  [selectDomain],
  (state) => state.logisticsUnderUpdate
);

export const selectUpdatingStatus = createSelector(
  [selectDomain],
  (state) => state.statusUnderUpdate
);

export const selectDownloadStatus = createSelector(
  [selectDomain],
  (state) => state.downloadInProgress
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectOrderCount = createSelector(
  [selectDomain],
  (state) => state.orderCount
);

export const selectUsers = createSelector([selectDomain], (state) =>
  state.companyUsers?.users?.map((user) => ({
    label: `${user.firstName} ${user.lastName || ""}`,
    value: user._id,
  }))
);

export const selectFilters = createSelector(
  [selectDomain],
  (state) => state.filters
);

export const selectSectors = createSelector(
  [selectDomain],
  (state) => state.sectors
);

export const selectPackages = createSelector(
  [selectDomain],
  (state) => state.packages
);

export const selectFetchingPackages = createSelector(
  [selectDomain],
  (state) => state.fetchingPackages
);

export const selectPackagesError = createSelector(
  [selectDomain],
  (state) => state.packagesError
);

export const selectProjectData = createSelector(
  [selectDomain],
  (state) => state.projectData
);

export const selectAgencies = createSelector(
  [selectDomain],
  (state) => state.agencies
);